//----------------------------------------------Registration From-----------------------------------//
function isEmail(email) {
    let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

function heightImgForm() {
    let left_block = $('.form-reg .form-reg__left'),
        right_block = $('.form-reg .form-reg__right');
    if ( window.innerWidth > 575 && (left_block.length != 0 && right_block.length != 0)) {
        let rightHeight = right_block.innerHeight(),
            leftHeight = left_block.innerHeight();
        if ( rightHeight !== leftHeight) {
            left_block.css({"height": rightHeight + "px"});
        }
    }
}

heightImgForm();
jQuery(document).ready(function ($) {
    $(window).resize(function () {
        heightImgForm();
    });

    $( ".form-reg__right_body_item" ).click(function() {
        let input = $(this).find("input");
        input.focus();
        $(this).addClass('focus');
        if (input.hasClass('invalid')) {
            input.removeClass('invalid');
        }
    });

    $( ".form-reg__right_body_btn" ).click(function() {
        let inputEmail = $(this).parent().find("#username").val();
        let inputPass = $(this).parent().find("#password").val();
        isEmail(inputEmail);
        if (isEmail(inputEmail) && inputPass.length >= 6) {
            window.open( window.site_option.ref_link_form, true );
        } else {
            if (!isEmail(inputEmail)) {
                $(this).parent().find("#username").addClass('invalid');
            }
            if (inputPass.length < 6) {
                $(this).parent().find("#password").addClass('invalid');
            }
        }
    });
});